// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Divider, Typography} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {Error} from '@material-ui/icons';

import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';

import {colors} from '../../../../../assets/styles/colors';

type Props = {
  isSaving?: boolean,
  open: boolean,
  handleClose: () => void,
  handleDeleteCoupon: () => void,
};
const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(5, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 330,
  },
  icon: {
    color: colors.error,
    fontSize: '3rem',
  },
  title: {
    textAlign: 'center',
    fontSize: '1.25rem',
    fontWeight: 600,
    margin: theme.spacing(1),
  },
  text: {
    textAlign: 'center',
    fontSize: '0.875rem',
    fontWeight: 400,
    marginBottom: theme.spacing(2),
  },
  button: {
    height: 40,
    fontSize: '1rem',
    alignSelf: 'stretch',
  },
}));

export default function DeleteCouponModal(props: Props) {
  const {isSaving, open, handleClose, handleDeleteCoupon} = props;
  const classes = useStyles();

  const handleCloseModal = () => {
    if (!isSaving) {
      handleClose();
    }
  };

  const handleSubmit = () => {
    handleDeleteCoupon();
    handleCloseModal();
  };

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <Error className={classes.icon} />
        <Typography className={classes.title}>
          ¿Está seguro que desea eliminar el cupón?
        </Typography>
        <Typography className={classes.text}>
          El cupón no podrá recuperarse.
        </Typography>
        <Divider />
        <CustomButton
          className={classes.button}
          variant="contained"
          onClick={handleSubmit}
        >
          Eliminar cupón
        </CustomButton>
        <CustomButton className={classes.button} onClick={handleCloseModal}>
          Cerrar
        </CustomButton>
      </div>
    </CustomModal>
  );
}

DeleteCouponModal.propTypes = {
  isSaving: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleDeleteCoupon: PropTypes.func.isRequired,
};
